import { render, staticRenderFns } from "./add_system_version_dialog.vue?vue&type=template&id=0bb17c7a&scoped=true&"
import script from "./add_system_version_dialog.vue?vue&type=script&lang=js&"
export * from "./add_system_version_dialog.vue?vue&type=script&lang=js&"
import style0 from "./add_system_version_dialog.vue?vue&type=style&index=0&id=0bb17c7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb17c7a",
  null
  
)

export default component.exports